<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col cols="12" xl="12">
				<b-alert
					v-if="notAllowedError"
					:show="dismissCountDown"
					dismissible
					variant="warning"
					@dismissed="dismissCountDown=0"
					@dismiss-count-down="countDownChanged"
				>
					<p>{{ deleteRoleErrorMessage }}</p>
				</b-alert>
				<!--<c-table :table-data="itemsArray" :per-page=10 hover striped bordered small fixed-->
				<!--caption="<i class='fa fa-align-justify'></i> Combined All Table"></c-table>-->
				<b-card no-header>
					<div slot="header" class="d-flex justify-content-between custom-card-header">
						<h5 class="card-header-title">{{ $t('roles.title')}}</h5>

						<div class="card-header-actions">
							<b-link
								@click="showCreateRoleModal"
								size="sm" variant="primary"
								v-if="$can('create', 'role')"
							>
								<i class="fa fa-user-plus" style="font-size: 1.2em; color: #53575B"></i>
							</b-link>
						</div>
					</div>

					<b-table class="generalTableClass" :busy="isBusy" hover="hover" striped="striped"
							 bordered="bordered" small="small"
							 fixed="fixed" responsive="sm" :items="rolesList" :fields="computedFields"
							 :current-page="currentPage" :per-page="perPage" show-empty>

						<!-- EMPTY SLOT FOR TABLE -->
						<template slot="empty" slot-scope="scope">
							<h4>{{ $t('empty') }}</h4>
						</template>
						<!-- EMPTY SLOT FOR TABLE -->

						<template slot="status" slot-scope="data">
							<b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
						</template>
						<template slot="name" slot-scope="data" class="col-md-8">
							<template v-if="$can('edit', 'role')">
								<p
									v-bind:key="data.item.id + 'name'"
									v-if="focusedData.id !== data.item.id"
									@dblclick="changeFocused(data)"
									v-b-tooltip.hover
									:title="$t('actions.update')"
								>
									{{ data.value }}
								</p>
								<b-form-input autofocus ref="roleNameRef"
											  autocomplete="off"
											  @focusout.native="inputUnfocused(data, data.value)"
											  @keydown.enter="inputUnfocused(data, data.value)"
											  v-bind:key="data.item.id + 'name'" v-model="data.value"
											  v-if="focusedData.id === data.item.id && focusedData.key === data.field.key"></b-form-input>
							</template>

							<template v-else>
								<p
									v-bind:key="data.item.id + 'name'"
								>
									{{ data.value }}
								</p>
							</template>

						</template>
						<template slot="permissions" slot-scope="data" class="col-md-8">
							<b-link :key="data.item.id"
									@click="permissionHandle(data.item.id,data.item.name)"
									v-if="$can('list', 'permissions by role')">
								{{ $t('roles.permissions')}}
							</b-link>
							<!--<router-link :to="{ name:'Roleperms', params:{id:data.item.id} }"></router-link>permm-->
						</template>
						<template slot="actions" slot-scope="data" class="col-md-8">
							<!--<b-link @click="deleteRole(data.item.id)"><i v-b-tooltip.hover title="Roleni o'chirish" class="fa fa-trash"></i></b-link>-->
							<!--<router-link :to="{ name:'Roleperms', params:{id:data.item.id} }"></router-link>permm-->
							<b-link :key="data.item.id + 'delete'"
									@click="onOpen(data.item.id)"
									:id="'popOverDelete'+data.item.id"
									v-if="$can('delete', 'role')"
							>
								<i class="fa fa-trash"></i>
							</b-link>
							<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
							<b-popover
								:key="data.item.id + 'popover'"
								:target="'popOverDelete'+data.item.id"
								placement="auto"
								container="myContainer"
								:ref="'popover'+data.item.id"
								class="refDeleteConfirm"
							>
								<template slot="title">
									<b-button @click="onClose(data.item.id)" class="close" aria-label="Close"
											  style="margin-left: 5px">
										<span class="d-inline-block" aria-hidden="true">&times;</span>
									</b-button>
									{{ $t('actions.deletetitle')}}
								</template>

								<div>
									<div class="row mt-1">
										<div class="col-6">
											<b-button variant="outline-danger" size="sm" block
													  @click="onClose(data.item.id)">{{ $t('actions.no')}}
											</b-button>
										</div>
										<div class="col-6">
											<b-button variant="outline-success" size="sm" block
													  @click="onOk(data.item.id)">{{ $t('actions.yes')}}
											</b-button>
										</div>
									</div>
								</div>
							</b-popover>
							<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
						</template>
					</b-table>
					<nav>
						<b-pagination :total-rows="rolesList.length" :per-page="perPage" v-model="currentPage"
									  :prev-text="$t('pagination.prev')"
									  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
					</nav>
				</b-card>
			</b-col>
			<b-modal ref="createRoleModal" hide-footer ok-title="Save" :title="$t('roles.title')">
				<div style="margin: 25px;">
					<p v-if="roleInputNotFilled" style="color: red;">{{$t('users-l.create.please-title')}}</p>
					<b-form-group
						label-align-sm="right"
						label-for="roleName"
						fa fa-user
						size="sm"
					>
						<b-input-group-prepend>
							<span class="input-group-text"><i class="fa fa-user fa-lg"></i></span>

							<b-form-input 	size="sm" :placeholder="$t('roles.name')" type="text" id="roleName"
										  v-model="newRole.name" autocomplete="off"/>
						</b-input-group-prepend>

					</b-form-group>

					<b-form-group
						label-align-sm="right"
						label-for="roleCode"
						fa fa-user
						size="sm"
					>
						<b-input-group-prepend>
							<span class="input-group-text"><i class="fa fa-user fa-lg"></i></span>

							<b-form-input 	size="sm" :placeholder="$t('roles.code')" type="text" id="roleCode"
										  v-model="newRole.code" autocomplete="off"/>
						</b-input-group-prepend>

					</b-form-group>
					<div class="row mt-3 createRoleModalButtons">
						<div class="col-6">
							<b-button variant="outline-danger" size="sm" block @click="closeCreateRoleModal">
								{{$t('actions.cancel')}}
							</b-button>
						</div>
						<div class="col-6">
							<b-button variant="outline-success" size="sm" block @click="saveRole">
								{{$t('actions.save')}}
							</b-button>
						</div>
					</div>
				</div>
			</b-modal>
		</b-row>
	</div>
</template>

<script>
	import ColorTheme from './ColorTheme'
	import {shuffleArray} from '@/shared/utils'
	import {mapGetters, mapActions, mapState} from 'vuex'

	export default {
		name: 'Colors',
		components: {ColorTheme},
		data: () => {
			return {
				/* DATA FOR ALERT WHEN DELETED 'NOT_ALLOWED' ROLE BEGIN */
				dismissCountDown: 4,
				counterForAlert: 0,
				/* DATA FOR ALERT WHEN DELETED 'NOT_ALLOWED' ROLE END */
				currentPage: 1,
				perPage: 20,
				editable: false,
				isBusy: false,
				focusedData: {
					id: null,
					key: null
				},

				roleInputNotFilled: false,
				newRole: {
					name: '',
					code: ''
				},
				fields: [
					{
						key: 'id',
						'class': 'role_id',
					},
					{key: 'name'},
					{key: 'code'},
					{key: 'permissions'},
					{
						key: 'actions',
						'class': 'table_actions'
					}
				],
			}
		},
		methods: {
			/* POPOVER METHODS BEGIN */
			onOpen(itemId) {
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('open')
			},
			onClose(itemId) {
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('close')
			},
			async onOk(itemId) {
				this.onClose(itemId)
				await this.deleteRole(itemId);
			},
			/* POPOVER METHODS END */

			countDownChanged(dismissCountDown) {
				if (dismissCountDown <= 1) {
					dismissCountDown = 3;
				}
				this.dismissCountDown = dismissCountDown
			},
			async deleteRole(id) {
				await this.deleteRoleWithId(id);
				if (this.notAllowedError) {
					setTimeout(() => {
						this.$store.commit('roles/deleteRoleError', {message: '', boolean: false})
					}, 4000)
				}
			},
			async saveRole() {
				if (this.newRole.name != '' && this.newRole.code != '') {
					this.roleInputNotFilled = false;
					await this.createNewRole(this.newRole);
					this.getRolesList(this.currentPage);
					this.newRole.name = '';
					this.newRole.code = '';
					this.currentPage = 1;
					this.$refs.createRoleModal.hide();
				} else {
					this.roleInputNotFilled = true;
				}
			},
			showCreateRoleModal() {
				this.roleInputNotFilled = false;
				this.$refs.createRoleModal.show();
			},
			closeCreateRoleModal() {
				this.roleInputNotFilled = false;
				this.$refs.createRoleModal.hide();
			},
			async inputUnfocused(data, newName) {
				let newRole = {...data.item};
				newRole.name = newName;
				if (data.item.name != newName) {
					await this.editRole(newRole);
					this.getRolesList();
				}
				this.focusedData.id = null;
				this.focusedData.key = null
			},
			permissionHandle(id) {
				this.$router.push(`/user-management/roles/${id}`)
			},
			changeFocused(data) {
				this.focusedData.id = data.item.id;
				this.focusedData.key = data.field.key;
				setTimeout(() => {
					if (data.field.key === 'name') {
						this.$refs["roleNameRef"].$el.focus();
					}
				}, 50)
			},
			...mapActions('roles', [
				'getRolesList', 'editRole', 'createNewRole', 'deleteRoleWithId'
			]),

			getBadge(status) {
				return status === 'Active' ? 'success'
					: status === 'Inactive' ? 'secondary'
						: status === 'Pending' ? 'warning'
							: status === 'Banned' ? 'danger' : 'primary'
			},
		},
		computed: {
			...mapState('roles', [
				'notAllowedError', 'deleteRoleErrorMessage'
			]),
			...mapGetters('roles', [
				'rolesList'
			]),
			// BU DATA TARJIMA REACTIVE ISHLASHI UN COMPUTED ICHIGA YOZILYAPTI DATA NI ICHIDA THIS.$T QILIB ISHLATSA BO'LADI AMMO U REACTIVE BO'LMAYDI
			computedFields() {
				return [
					{
						key: 'id',
						label: this.$t('roles.Id'),
						'class': 'role_id',
					},
					{
						key: 'name',
						label: this.$t('roles.name')
					},
					{
						key: 'code',
						label: this.$t('roles.code')
					},
					{
						key: 'permissions',
						label: this.$t('roles.permissions')
					},
					{
						key: 'actions',
						label: this.$t('actions.title'),
						'class': 'table_actions'
					}
				]
			}

		},
		async created() {
			this.isBusy = true;
			await this.getRolesList();
			this.isBusy = false;
		}
	}
</script>
